import { useClientTokenManager } from '@cko/dashboard-shared';

export const useGetNotificationsAvailability = () => {
  const {
    tokenProperties: { userType, permissions },
  } = useClientTokenManager();

  const userHasPermissions =
    permissions.includes('balances:read') ||
    permissions.includes('invoices:read') ||
    permissions.includes('disputes:read') ||
    permissions.includes('payouts:read') ||
    permissions.includes('rfi:read');

  const isExternalUser = userType === 'External';

  return { isNotificationsAvailable: Boolean(isExternalUser && userHasPermissions) };
};
